export enum FormatFile {
  PDF = 'PDF',
  XLSX = 'XLSX',
  CSV = 'CSV'
}

export const optionsFormatExport = [
  {
    id: 1,
    title: 'CSV',
    label: FormatFile.CSV,
    type: FormatFile.CSV,
    color: '#239706'
  },
  {
    id: 2,
    title: 'PDF',
    label: FormatFile.PDF,
    type: FormatFile.PDF,
    color: '#D22419'
  },
  {
    id: 3,
    title: 'EXCEL',
    label: FormatFile.XLSX,
    type: FormatFile.XLSX,
    color: '#3CD82F'
  }
] as const;

export const MAXIMUN_ROWS_IN_PDF = 15000;
export const MESSAGE_ERROR_PDF = 'errorMessages.exportLimitExceeded';

const EXCEL_SHEET_INVALID_CHARS = /[:\\/?*[\]]/g;
const FILE_NAME_INVALID_CHARS = /[\\/:*?"<>|]/g;
const MAX_EXCEL_SHEET_NAME_LENGTH = 31;

/** Nombre de hoja válido para Excel (máx. 31 caracteres, sin : \\ / ? * [ ]). */
export function sanitizeExcelSheetName(name: string): string {
  const sanitized = name.replace(EXCEL_SHEET_INVALID_CHARS, '-').trim();
  if (!sanitized) return 'Export';
  return sanitized.substring(0, MAX_EXCEL_SHEET_NAME_LENGTH);
}

/** Nombre de archivo seguro para descarga en Windows. */
export function sanitizeExportFileName(name: string): string {
  const sanitized = name.replace(FILE_NAME_INVALID_CHARS, '-').trim();
  return sanitized || 'Export';
}
